<template>
	<div>
		<v-row class="mt-5" >
			<v-col cols="6">
				<v-toolbar color="primary" dark>
					<v-toolbar-title>Add Application</v-toolbar-title>
				</v-toolbar>
				<v-card>
					<v-card-text>
						<v-row  >
							<v-col cols="6">
								<v-text-field label="Name" v-model="app.name" name="name" class="required"
									v-validate="'required'" :error-messages="errors.collect('name')" required></v-text-field>
							</v-col>
							<v-col cols="6" />
							<v-col cols="12">
								<v-textarea
									label="Description"
									v-model="app.description"
								></v-textarea>
							</v-col>
							<v-col class="pr-3" cols="6" >
								<v-text-field label="Customer" v-model="app.customer"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-select persistent-hint v-model="app.region" label="Region" :items="regions" name="region" class="required"
									v-validate="'required'" :error-messages="errors.collect('region')" required></v-select>
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu1" label="Custom Logo Image" name="custom-logo" type="image" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6" />
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu2" label="Holter Report Config" name="holter-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu3" label="Holter Analysis Config" name="holter-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu4" label="Event Report Config" name="event-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu5" label="Event Analysis Config" name="event-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu6" label="Snapshot Report Config" name="snapshot-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu7" label="Snapshot Analysis Config" name="snapshot-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="12">
								<v-checkbox v-model="app.useBetaFeatures" label="Use Beta Features" />
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn @click="add" color="primary" :disabled="errors.any() || adding" :loading="adding">Add Application</v-btn>
					</v-card-actions>
				</v-card>

			</v-col>
		</v-row>
	</div>

</template>

<script>
import analysisApi from "../../analysisApi";
import { actionTypes } from "../../store-types";
import FileUpload from "../file-upload.vue";

export default {
	props: {
		partnerId: Number,
	},
	components: {
		FileUpload,
	},
	data() {
		return {
			app: {
				name: null,
				description: null,
				customer: null,
				region: null,
				logo: null,
				partnerId: this.partnerId,
				applicationFiles: [],
				useBetaFeatures: false,
			},
			adding: false,
		};
	},
	computed: {
		regions() {
			return [...this.config.lists.requestRegions];
		},
	},
	methods: {
		add() {
			this.$validator.validateAll()
				.then((valid) => {
					if (!valid) {
						return Promise.resolve();
					}

					this.adding = true;
					return analysisApi.addApplication(this.app)
						.then(() => {
							this.$emit("add");
							this.$store.dispatch(actionTypes.LOAD_CONFIG);
							this.clearForm();
							this.$validator.reset();
							this.showToast("success", "Application Added");
						})
						.catch((e) => {
							this.showError(e);
						})
						.finally(() => {
							this.adding = false;
						});
				});
		},
		fileClear(name) {
			this.app.applicationFiles = this.app.applicationFiles.filter(f => !f.fileName.startsWith(name));
		},
		fileChange(data) {
			this.app.applicationFiles.push(data);
		},
		clearForm() {
			this.app = {
				name: null,
				description: null,
				customer: null,
				region: null,
				logo: null,
				partnerId: this.partnerId,
				applicationFiles: [],
				useBetaFeatures: false,
			};
			this.$refs.fu1.clear();
			this.$refs.fu2.clear();
			this.$refs.fu3.clear();
			this.$refs.fu4.clear();
			this.$refs.fu5.clear();
			this.$refs.fu6.clear();
			this.$refs.fu7.clear();
		},
	},
};
</script>
